import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import useVuelidate from '@vuelidate/core';

import { GET_TEMP_REPORT } from '@/store/reports/constants';
import { BUYING_STATUS, BUYING_STATUS_TEXT, SNACKBAR_TYPES } from '@/utils/constants';
import { TEMP_REPORT_EXPIRED } from '@/utils/errorCodeList';

export default {
  name: 'TempReport',
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      loading: false,
      isExpired: false,
      report: {},
    };
  },
  computed: {
    calculateTime() {
      const { calculate_time: calculateTime = '' } = this.report;
      return dayjs(calculateTime).format('YYYY/MM/DD HH:mm:ss');
    },
    statusTagClass() {
      const { status } = this.report;
      const TAG_CLASSES = {
        [BUYING_STATUS.ONGOING]: 'bg-blue-50 border-blue-100 text-blue-500',
        [BUYING_STATUS.ENDED]: 'bg-light-gray-500 border-gray-300 text-gray-700',
        [BUYING_STATUS.FINISHED]: 'bg-seaweed-green-50 border-seaweed-green-100 text-seaweed-green-500',
        [BUYING_STATUS.CANCELED]: 'bg-light-gray-500 border-gray-50 text-gray-500',
        [BUYING_STATUS.SCHEDULED]: 'bg-blue-50 border-blue-100 text-blue-500',
      };
      return TAG_CLASSES[status] || '';
    },
    statusText() {
      const { status } = this.report;
      return BUYING_STATUS_TEXT[status] || '';
    },
    orderItems() {
      const { order_items: orderItems = [] } = this.report;
      return orderItems;
    },
    currentYear() {
      return dayjs().format('YYYY');
    },
  },
  async created() {
    try {
      this.loading = true;
      const { shareKey = '' } = this.$route.params;
      if (shareKey) {
        await this.loadTempReport(shareKey);
      }
    } catch (error) {
      if (error?.status === TEMP_REPORT_EXPIRED) {
        this.isExpired = true;
      } else {
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '載入資訊失敗，請重新整理網頁。',
          msg: error?.message || '發生未知錯誤，請再試一次',
        });
      }
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions('reports', {
      getTempReport: GET_TEMP_REPORT,
    }),
    async loadTempReport(shareKey) {
      this.report = await this.getTempReport(shareKey) || {};
      console.log(this.report);
    },
    extraReceiveTimes(times = []) {
      const newArr = cloneDeep(times);
      newArr.shift();
      return newArr;
    },
  },
};
